<template>
  <div class="buyer-layout"
    v-loading="loading"
    element-loading-spinner="not"
    element-loading-background="rgba(255, 255, 255, 0.8)">
    <div class="buyer-layout2">
    <!--邮件主体部分-->
    <div class="buyer-content">
      <div style="display: flex; flex-direction: column; width: 100%; height: 100%">
        <div class="reply-detail flex">
          <div class="reply-detail-title">
            <gj-alert border type="warning" show-icon>请不要在同一台电脑上打开不同店铺的亚马逊后台链接，若需要打开，请复制到店铺常用电脑上操作</gj-alert>
          </div>
          <div style="display: flex; flex-direction: column; width: 100%;flex: 1;overflow: auto">
            <div class="reply-message-content">
              <template v-for="nrf in data.reviewFeedback">
                <div v-if="nrf == 'reviewVO'" :key="nrf" class="review-content  gj-mb16">
                  <div>
                    <span class="gj-mr16">{{data.reviewVO.reviewDate}}</span>
                    <gj-link :href="data.reviewVO.userUrl" target="_blank" class="colorBlue gj-mr14">{{data.reviewVO.amazonUserName}}</gj-link>
                    <gj-tag v-if="data.reviewVO.isER" type="dark" class="gj-mr8" style="height: 18px; line-height: 18px;" :color="tagColors.lightGrayDark">ER</gj-tag>
                    <gj-tag v-if="data.reviewVO.isHOF" type="dark" class="gj-mr8" style="height: 18px; line-height: 18px;" :color="tagColors.lightGrayDark">HOF</gj-tag>
                    <gj-tag v-if="data.reviewVO.isVINE" type="dark" class="gj-mr8" style="height: 18px; line-height: 18px;" :color="tagColors.lightGrayDark">VINE</gj-tag>
                    <gj-tag v-if="data.reviewVO.isTOPC" type="dark" class="gj-mr8" style="height: 18px; line-height: 18px;" :color="tagColors.lightGrayDark">TOPC</gj-tag>
                    <gj-tag v-if="data.reviewVO.isTOPR" type="dark" class="gj-mr8" style="height: 18px; line-height: 18px;" :color="tagColors.lightGrayDark">TOPR</gj-tag>
                    <gj-tag v-if="data.reviewVO.verified" type="dark" class="gj-mr8" style="height: 18px; line-height: 18px;" :color="tagColors.lightGrayDark">VP</gj-tag>
                  </div>
                  <div class="reply-message-content-item">
                    <div class="line18 color666"><span class="weight600 color333">Review：</span>{{data.reviewVO.title}}</div>
                    <div class="reply-message-item-content">
                      {{data.reviewVO.content}}
                    </div>
                    <div class="gj-mb6">
                      <el-row>
                        <el-col :span="10">
                          <div class="flex">
                            <span class="gj-mr14 color999">星级</span><el-rate v-model="data.reviewVO.star" disabled></el-rate>
                          </div>
                        </el-col>
                        <el-col :span="4"><span class="gj-mr12 size12 color999">点赞数</span><span class="color666 size12">{{data.reviewVO.helpfulNum}}</span></el-col>
                        <el-col :span="10"  class="gj-label--right"><span class="gj-mr12 size12 color999">评论编号</span><span class="color666 size12">{{data.reviewVO.reviewCode}}</span></el-col>
                      </el-row>
                    </div>
                    <div class="flex align-center justify-start" v-if="isMeaningful(data.reviewVO.media)">
                      <template v-for="item in data.reviewVO.media.reviewImageUrls">
                        <gj-image class="gj-mr4" :src="item" :key="item"></gj-image>
                      </template>
                      <template v-for="(item,index) in data.reviewVO.media.videos">
                        <gj-video :key="index" class="gj-mr4" v-if="item.videoUrl" :video-slate-img-url="item.videoSlateImgUrl" :video-url="item.videoUrl" >
                        </gj-video>
                        <gj-image :key="index" v-else :src="item.videoSlateImgUrl" style="margin-left: 10px;"></gj-image>
                      </template>
                    </div>
                  </div>
                </div>
                <div v-if="nrf == 'feedbackVO'" :key="nrf" class="review-content gj-mb16">
                  <div>
                    <span class="gj-mr16">{{data.feedbackVO.feedbackDateStr}}</span>
                    <gj-tag v-if="data.feedbackVO.isER" type="dark" class="gj-mr8" :color="tagColors.lightGrayDark">ER</gj-tag>
                    <gj-tag v-if="data.feedbackVO.isHOF" type="dark" class="gj-mr8" :color="tagColors.lightGrayDark">HOF</gj-tag>
                    <gj-tag v-if="data.feedbackVO.isVINE" type="dark" class="gj-mr8" :color="tagColors.lightGrayDark">VINE</gj-tag>
                    <gj-tag v-if="data.feedbackVO.isTOPC" type="dark" class="gj-mr8" :color="tagColors.lightGrayDark">TOPC</gj-tag>
                    <gj-tag v-if="data.feedbackVO.isTOPR" type="dark" class="gj-mr8" :color="tagColors.lightGrayDark">TOPR</gj-tag>
                    <gj-tag v-if="data.feedbackVO.verified" type="dark" class="gj-mr8" :color="tagColors.lightGrayDark">VP</gj-tag>
                  </div>
                  <div class="reply-message-content-item">
                    <div class="weight600 line18"><span class="color333">Feedback：</span></div>
                    <div class="reply-message-item-content">
                      {{data.feedbackVO.comments}}
                    </div>
                    <div class="gj-mb6">
                      <el-row>
                        <el-col :span="10">
                          <div class="flex">
                            <span class="gj-mr14 color999">星级</span><el-rate v-model="data.feedbackVO.rating" disabled></el-rate>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
              </template>
              <div v-for="(item, index) in data.messages"
                   :key="index" :class="{'message-mb15': index + 1 !== data.messages.length, 'reply-message-item--right': !item.buyerMessage}">
                <div class="reply-message">
                  <div class="reply-message-date" :class="{'reply-message-date--right': !item.buyerMessage}">
                    {{item.messageDate}} <span class="gj-ml5">{{item.userName}}</span>
                  </div>
                  <div class="reply-message-content-item" :style="{backgroundColor: item.sendStatus === 0 ? '#FFF1F0' : !item.buyerMessage ? '#EEEFF0' : '#EEF3FB'}">
                    <div class="size12 color333 weight600" v-if="isMeaningful(item.sendTypeInfo) && item.sendTypeInfo.indexOf('关怀邮件') >= 0">{{item.sendTypeInfo}}</div>
                    <div class="size12 color333 weight600" v-else-if="isMeaningful(item.sendTypeInfo) && item.sendTypeInfo.indexOf('联系买家') >= 0">{{item.sendTypeInfo}}</div>
                    <div v-html="item.messageBody"></div>
                    <template v-if="isMeaningful(item.postContext)">
                        <div v-if="item.more">
                          {{item.postContext}}
                          {{'\n'}}<gj-button @click.stop="item.more = false" type="text">收起</gj-button>
                        </div>
                        <div v-else>
                          <gj-button @click.stop="item.more = true" type="text">更多</gj-button>
                        </div>
                    </template>
                    <template v-if="isMeaningful(item.attachments) && item.attachments.length > 0">
                      <div>
                        <template v-for="(attItem, index) in item.attachments">
                          <gj-link @click="downloadAttFile(attItem.id)" :key="index" type="text" icon="el-icon-document" class="gj-mr8 gj-mt5">{{attItem.name}}</gj-link>
                        </template>
                      </div>
                    </template>
                    <i class="el-icon-success reply-message-send-succ" v-if="!item.buyerMessage && item.sendStatus === 1"></i>
                  </div>
                  <div class="reply-message-remarks-item" v-if="!item.buyerMessage && isMeaningful(item.memo)">
                    <div class="color999 wid35">备注</div>
                    <div class="color666 flex1">{{item.memo}}</div>
                  </div>
                  <div class="flex justify-between align-baseline" v-if="!item.buyerMessage && item.sendStatus === 0">
                    <div>
                      <gj-link class="colorRed" type="text" style="margin-left: 0 !important" icon="el-icon-warning">发送失败</gj-link>
                      <div class="color999 wid240 size12 gj-pl17" v-if="item.resultDesc">({{item.resultDesc}})</div>
                    </div>
                    <div>
                      <gj-button @click="resend(item)" :loading="resendLoading" type="text">重新发送</gj-button>
                      <span v-if="item.sendFailTip"  @click="notPrompted(item)" style="cursor:pointer;" class="color666 gj-ml24 size12">我知道了，不在提醒</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="padding-right: 9px;">
              <div class="reply-message-template">
                <div style="width: 70%; margin-right: 10px;">
                  <gj-input v-model="subject" placeholder="请输入邮件主题" width="100%"></gj-input>
                </div>
                <div style="width: 30%">
                  <!-- <gj-select
                      v-model="emailTemplate"
                      :options="emailTemplateOption"
                      @input="changeEmailTpl"
                      placeholder="请选择模板" width="100%"></gj-select> -->
                  <el-cascader
                    v-model="emailTemplate"
                    placeholder="请选择模板"
                    :options="emailTemplateOption"
                    size="small"
                    @change="emailgHandleChange"
                    :props="{
                      children: 'marketMailTemplateVOList',
                      value: 'id',
                      label: 'name',
                      emitPath: false,
                    }"
                    style="width: 100%; height: 32px;"
                  ></el-cascader>
                </div>
              </div>
              <div>
                <gj-wang-editor
                  ref="gjWangEditor"
                  v-model="sendMessage"
                  :maxLength="4000"
                  height="140">
                </gj-wang-editor>
                <template v-if="uploadAttFiles.length > 0">
                  <div class="upload-att">
                    <template v-for="(attItem, index) in uploadAttFiles">
                      <div :key="index">
                        {{attItem.name}}
                        <i class="el-icon-close att-close" @click="removeAttFile(attItem.attId)"></i>
                      </div>
                    </template>
                  </div>
                </template>
                <el-row class="flex align-center" :style="{paddingTop: uploadAttFiles.length > 0 ? 'unset' : '10px'}" style="padding-bottom: 12px;">
                  <el-col :span="3">
                    <gj-upload-attach
                      containerType="mailReply"
                      :file-list="uploadAttFiles"
                      accept=".txt,.jpeg,.jpg,.png,.doc,.docx,.pdf,.mp4"
                      :is-icon="true"
                      :noRemove="noRemove"
                    ></gj-upload-attach>
                  </el-col>
                  <el-col :span="3">
                    <gj-popover
                      v-model="addRemarksVisible"
                      width="350"
                      placement="top"
                      trigger="click"
                      @close="addRemarksVisible = false">
                      <template slot="reference">
                        <gj-button type="text" style="position: relative;">
                          <i class="el-icon-chat-dot-round"></i>
                          <i v-if="remarks" class="reddot"></i>
                          添加备注
                        </gj-button>
                      </template>
                      <template>
                        <gj-input
                         v-model="remarks"
                          type="textarea"
                          :rows="4"
                          placeholder="请输入内容"
                          style="width: 100%">
                        </gj-input>
                        <div style="text-align: right; margin-top: 14px;">
                          <gj-button @click="addRemarksVisible = false">取消</gj-button>
                          <gj-button type="primary" @click="addRemarksVisible = false">确定</gj-button>
                        </div>
                      </template>
                    </gj-popover>
                  </el-col>
                  <el-col :span="18" class="flex justify-end align-center" style="text-align: right; padding: 0">
                    <template  v-if="$permission('ticket:edit')">
                      <template v-if="data.ticketStatus === mailTypeStatusEnum.PENDING">
                        <gj-button :loading="TrackingLoading" type="text" class="color333" @click="updateStatus(mailTypeStatusEnum.TRACKING)">
                          <div class="flex align-center">
                            <img src="../../../../../assets/images/crm/tracked.png" alt="">
                            标为待跟踪
                          </div>
                        </gj-button>
                      </template>
                      <template v-if="(data.ticketStatus === mailTypeStatusEnum.PENDING || data.ticketStatus === mailTypeStatusEnum.TRACKING) && (mailType === mailTypeEnum.BUYER_MAIL || mailType===mailTypeEnum.NR || mailType===mailTypeEnum.NF)">
                        <gj-button :loading="DoneLoading" type="text" class="color333" @click="updateStatus(mailTypeStatusEnum.DONE)">
                          <div class="flex align-center">
                            <img src="../../../../../assets/images/crm/processed.png" alt="">标为已处理
                          </div>
                        </gj-button>
                      </template>
                    </template>
                    <gj-button
                      v-if="((mailType === mailTypeEnum.BUYER_MAIL && (data.feedbackId || (item.reviewRelateOrderId != '0' && isMeaningful(item.reviewRelateOrderId)))) || mailType===mailTypeEnum.NR || mailType===mailTypeEnum.NF)&&(data.ticketStatus === mailTypeStatusEnum.PENDING || data.ticketStatus === mailTypeStatusEnum.TRACKING || data.ticketStatus === mailTypeStatusEnum.DONE)"
                      type="text"
                      class="color333"
                      @click="placeOnFile">
                      <div class="flex align-center">
                        <img src="../../../../../assets/images/crm/placefile.png" alt="">归档
                      </div>
                    </gj-button>
                    <gj-button :loading="sendLoading" type="primary" @click="send">发送</gj-button>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="height: 100%;width: 1px;background-color: #eeeff0; flex: none;"></div>

    <!-- 订单详情&系统日志-->
    <div class="buyer-email-detail"
      v-loading="relatedLoading"
      element-loading-spinner="not"
      element-loading-background="rgba(255, 255, 255, 0.8)">
      <div class="flex flex-direction-column" style="height: 100%">
            <div class="buyer-email-detail-top">
                <div v-if="isMeaningful(relatedOrder.id)" class="top-item flex justify-between align-center" style="margin-top: 0">
                  <span class="top-item-label color333 weight600" style="margin: 0;">订单详情</span>
                  <div>
                    <gj-button type="text" @click="addMultiChannelOrder(relatedOrder.id)" v-if="$permission('order:createFulfillmentOrder')">
                      创建多渠道订单>>
                    </gj-button>
                    <gj-button v-if="$permission('order:refund')" @click.stop="refund(relatedOrder.id)" type="text">
                      退款>>
                    </gj-button>
                  </div>
                </div>
                <div class="top-item flex" style="margin-top: 0">
                  <span class="top-item-label">订单编号</span>
                  <span>
                    <template v-if="isMeaningful(data.orderId)">
                      <div class="flex align-center" style="height: 100%;" v-if="!isMeaningful(relatedOrder.id)">
                        {{data.orderId}}
                        <gj-copy-icon v-if="isMeaningful(data.orderId)" :content="data.orderId"/>
                      </div>
                      <div class="flex align-center" style="height: 100%;" v-else>
                        <gj-button type="text" style="padding: 0;margin: 0!important;" @click="opOrderDetail(relatedOrder.marketId, relatedOrder.orderId)">
                          {{relatedOrder.orderId}}
                        </gj-button>
                        <gj-copy-icon v-if="isMeaningful(relatedOrder.orderId)" :content="relatedOrder.orderId"/>
                      </div>
                    </template>
                  </span>
                </div>

                <div class="top-item flex" style="padding-bottom: 2px;margin-left: 12px;">
                  <template v-for="(item, index) in saleOrderStatus">
                    <template v-if="item.id === relatedOrder.orderStatus">
                      <gj-tag type="dark" :key="index" :color="item">
                        {{item.text}}
                      </gj-tag>
                    </template>
                  </template>
                  <template v-if="relatedOrder.fulfillmentChannel === 'AFN'">
                    <gj-tag type="dark" :color="tagColors.blueDark">
                      FBA
                    </gj-tag>
                  </template>
                  <template v-if="relatedOrder.fulfillmentChannel === 'MFN'">
                    <gj-tag type="dark" :color="tagColors.greenDark">
                      FBM
                    </gj-tag>
                  </template>
                </div>

                <div class="top-item flex">
                  <span class="top-item-label">订购时间</span>

                  <span class="color666">{{relatedOrder.purchaseDate || '-'}}</span>
                </div>

                <div class="top-item flex">
                  <span class="top-item-label">发货时间</span>

                  <span class="color666">{{relatedOrder.shipDate || '-'}}</span>
                </div>

                <div class="top-item flex">
                  <span class="top-item-label">送达时间</span>

                  <span class="color666">{{relatedOrder.deliveryDate || '-'}}</span>
                </div>

                <div class="top-item flex">
                  <span class="top-item-label">物流跟踪号</span>

                  <span class="color666">{{relatedOrder.trackingNumber || '-'}}</span>
                </div>

                <div class="top-item flex">
                  <span class="top-item-label">关联订单</span>

                  <template v-if="isMeaningful(relatedOrder.relatedOrders) && relatedOrder.relatedOrders.length > 0">
                    <el-popover
                        trigger="hover"
                        placement="left"
                    >
                      <span slot="reference">
                        <gj-button style="padding: 0;margin: 0!important;" type="text" @click="opOrderDetail(data.marketId, relatedOrder.relatedOrders[0].orderId)">
                          {{relatedOrder.relatedOrders[0].orderId}}
                          <i class="el-icon-arrow-down"></i>
                        </gj-button>
                      </span>
                      <div style="width: 350px">
                        <div style="display: flex; padding: 10px">
                          <div class="column column-label--color" style="font-weight: bold;">
                            订单编号
                          </div>
                          <div class="column column-label--color" style="font-weight: bold;">
                            订购时间
                          </div>
                        </div>
                        <div style="display: flex; padding: 10px"
                            :style="{paddingTop: index === 0 ? '0' : ''}"
                            v-for="(item, index) in relatedOrder.relatedOrders.map(v => ({label: v.orderId, value: v.purchaseDate}))"
                            :key="index" :class="{'column--color': index % 2 !== 0}">
                          <div class="column column-label--color" >
                            <gj-button style="padding: 0;" type="text" @click="opOrderDetail(data.marketId, item.label)">{{item.label}}</gj-button>
                          </div>
                          <div class="column column-value--color" >{{item.value}}</div>
                        </div>
                      </div>
                    </el-popover>
                  </template>
                  <template v-else>
                    <span class="color666">-</span>
                  </template>
                </div>

    <!--            <div class="top-item flex">-->
    <!--              <span class="top-item-label">订单金额</span>-->
    <!--              {{relatedOrder.orderTotal || '-'}}-->
    <!--            </div>-->

                <div class="buyer-email-detail-items">
                  <div class="gj-mb10" v-for="(item,index) in relatedOrder.listings" :key="index">
                    <div style="padding: 6px 0 8px;color: #333333;">商品{{index+1}} <span class="gj-ml24"><span class="color666">数量：</span>{{relatedOrder.quantity || 0}}</span></div>
                    <div class="list-item-title">
                      <gj-tooltip :content="item.title" :text-line="1"><span class="color666">{{item.title}}</span></gj-tooltip>
                    </div>
                    <div class="flex" style="padding: 4px 0 8px;">

                      <gj-image size="60" :src="item.imageUrl"></gj-image>

                      <div style="padding-left: 13px;">
                        <div class="flex align-center">
                          <span class="list-item-name" style="width: 30px;">ASIN</span>
                          <gj-tooltip :content="item.asin" :text-line="1"><gj-link :href="item.asinUrl" target="_blank">{{item.asin}}</gj-link></gj-tooltip>
    <!--                      <span>{{item.asin}}</span>-->
                        </div>
                        <div class="flex align-center">
                          <span class="list-item-name">MSKU</span>
                          <gj-tooltip :content="item.msku" :text-line="1"><span class="color333">{{item.msku}}</span></gj-tooltip>
    <!--                      <span>{{item.msku}}</span>-->
                        </div>
                        <div class="flex align-center">
                          <span class="list-item-name" style="width: 30px;">SKU</span>
                          <gj-tooltip :content="item.sku" :text-line="1"><span class="color333">{{item.sku}}</span></gj-tooltip>
    <!--                      <span>{{item.sku}}</span>-->
                        </div>
                      </div>
                    </div>

                    <div>
                      <div class="tagLabel">标签</div>
                      <gj-tag-cascader v-model="item.tagIds" @visitChange="tagIdsChange(item, $event)" style="width:100%;"></gj-tag-cascader>
                      <div class="tagLabel">标签备注</div>
                       <gj-textarea
                          v-model="item.memo"
                          @blur="tagIdsChange(item, $event)"
                          :styles="{ height: '32px', width: '100%' }"
                        >
                        </gj-textarea>
                    </div>

                    <!-- <div style="margin-bottom: 12px;">
                      <div class="flex align-center" style="margin-bottom: 12px;">
                        <span style="width: 48px;text-align: right;">标签</span>
                        <div class="bigBox align-center">
                          <gj-tooltip :text-line="1" effect="light" popperClass="lightTip">
                            <template #content>
                              <div class="contenBox">
                                <span v-for="(i,index) in item.tags" :key="index" class="tagSpan">
                                      <gj-tag  :color="tagColors.orange" type="plain" class="contentLongTag">{{i.name}}</gj-tag>
                                </span>
                              </div>
                            </template>
                            <div class="tagsBox">
                              <span v-for="(i,index) in item.tags" :key="index" class="tagSpan">
                                <gj-tag  :color="tagColors.orange" type="plain" class="tooLongTag">{{i.name}}</gj-tag>
                              </span>
                            </div>
                          </gj-tooltip>
                          <div v-if="$permission('tag:marking')" class="editIcon" @click="editTags(item)">
                            <i class="el-icon-edit"></i>
                          </div>
                        </div>
                      </div>

                      <div class="flex align-center">
                        <span>标签备注</span>
                        <div class="bigBox">
                          <gj-tooltip :text-line="1" :content="item.memo || '-'" popperClass="lightTip">
                            {{item.memo || '-'}}
                          </gj-tooltip>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="buyer-email-detail-bottom">
                <!-- <div class="flex align-center" style="margin-bottom: 12px;">
                  邮件备注
                  <gj-input placeholder="请输入备注" v-model="data.memo" @change="updateMemo" class="detail-input"></gj-input>
                </div> -->
                <div class="flex align-center" v-if="mailType===mailTypeEnum.NR">
                  <div class="flex align-center color666">
                    匹配结果
                    <gj-help class="detail-bottom-icon" style="padding: 4px;">
                      NR邮件为积加系统匹配销售订单生成的邮件，不一定是真实留评用户，通过人工标注匹配结果，系统将对取正确的数据进行跟踪结果记录
                    </gj-help>
                  </div>
                  <gj-select
                    v-model="data.matchResult"
                    :options="[
                      {id:2,text:'无法判断'},
                      {id:1,text:'正确'},
                      {id:0,text:'错误'}
                    ]"
                    @change="updateMatchResult"
                    placeholder="请选择"
                    :disabled="isMeaningful(data.matchResult)"
                    class="detail-input">
                  </gj-select>
                </div>

                <div style="padding-left: 83px;color: #999;" v-if="mailType===mailTypeEnum.NR">
                  <i class="iconfont icontishixiangqing detail-bottom-icon" style="margin-right: 5px;"></i>请谨慎选择，仅能选择一次
                </div>
              </div>
          </div>
    </div>

    </div>
  </div>
</template>

<script>
  import {isMeaningfulMixin, responseMixin} from "../../../../../minxins";
  import SaleOrderDetail from "../../../sale/saleOrder/modal/sale-order-detail";
  import SaleOrderRefund from '../../../sale/saleOrder/modal/sale-order-refund';
  import AddMultiChannelOrder from '../../../sale/saleOrder/add/add-multi-channel-order';
  import {isMeaningful, isMeaningless} from "../../../../../utils/common";
  import {
    getBuyerEmailDetail, //买家邮件详情
    getMailTemplateList, //获取回复模板
    sendMail,//发送回复
    updateCrmMemo,//修改邮件备注
    updateStatus,//标记跟踪、处理
    updateMatchResult,//邮件设置匹配类型
    getResolveBadComment, // 获取feedback邮件
    resendAgainEmail,
    remindIgnore,
    setTicketCollection
  } from "../../../../../api/crm";
  import { saveTagToListing } from "../../../../../api/common";
  import {getRelatedOrder, refund} from "../../../../../api/sale";
  import {mailTypeEnum, mailTypeStatusEnum} from "../reply-content/enum";
  import {downloadAttFile} from "../../../../../api/common";
  import MailTagsModal from '../reply-content/mail-tags-modal'
  import PlaceOnFileModal from '../reply-content/place-on-file-modal'
  import {tagColors} from "@/components/tag/tag-colors";
  import {saleOrderStatus} from "@/utils/options";
  import AppMailEditModal from "@/views/modules/system/market/modal/mail-edit-modal";
  import {mapGetters} from "vuex";
  import AppReviewDetail from "@/views/components/review-modal/review-detail-modal";
  import GjWangEditor from '@/components/wang-editor/gj-wang-editor';

  export default {
    name: "app-mail-reply-buyer-content",
    components: { GjWangEditor, GjTagCascader: () => import("@/components/cascader/gj-tag-cascader") },
    mixins: [isMeaningfulMixin, responseMixin],
    created() {
    },
    activated() {
      if (this.type === 'feedback') {
        this.getFeedbackDetail(this.feedbackItem)
      } else {
        this.getDetailRelated(this.item)
      }
    },
    props: {
      item: null,
      mailType: null,
      marketOptions:null,
      //有值时代表从review打开，禁用nr标签点击查看review
      type:null,
      feedbackItem: null,
    },
    data() {
      return {
        url:'',
        results:null,//匹配结果
        tabName:'detail',
        loading: false,
        relatedLoading: false,
        TrackingLoading: false,
        DoneLoading: false,
        sendLoading: false,
        resendLoading: false,
        activeName: 'orderDetail',
        data: {
          marketId: null
        },
        subject: '',
        relatedOrder: {},
        mailTypeStatusEnum: mailTypeStatusEnum,
        emailTemplate: null,
        emailTemplateOption: [],
        sendMessage: null,
        orderMemo: '',
        uploadAttFiles: [],
        tableCellEdit:true,
        tagColors,
        tagIds:[],
        tagOption:[],
        mailTypeEnum,
        saleOrderStatus,
        noRemove:false,//移除已上传的文件时，是否删除服务器上已上传的文件
        addRemarksVisible: false,
        remarks: '',
        market: null
      }
    },
    computed: {
      ...mapGetters({
        markets: 'authMarkets'
      })
    },
    watch: {
      item: {
        immediate: true,
        deep: true,
        handler(value) {
          this.data = {};
          this.activeName = 'orderDetail';
          this.relatedOrder = {};
          if (isMeaningful(value)) {
            this.loading = true;
            this.noRemove = true;
            this.emailTemplateMap = {};
            this.subject = value.subject;
            this.uploadAttFiles = []
            this.relatedLoading = true;
            this.getDetailRelated(value);
            this.$nextTick(()=>{
              this.noRemove = false;
            })
          }
        }
      },
      feedbackItem: {
        immediate: true,
        deep: true,
        handler(value) {
          this.data = {};
          this.activeName = 'orderDetail';
          this.relatedOrder = {};
          if (isMeaningful(value)) {
            this.loading = true;
            this.noRemove = true;
            this.emailTemplateMap = {};
            this.uploadAttFiles =  []
            this.relatedLoading = true;
            this.getFeedbackDetail(value);
            this.$nextTick(()=>{
              this.noRemove = false;
            })
          }
        }
      },
      uploadAttFiles:{
        deep: true,
        handler(val){
          this.$emit('updateFile',val)
        }
      },
      "data.marketId": {
        handler(val){
          let market = this.marketOptions.filter(r => r.id === val)[0]||{account:''};
          this.market = market
        }
      },
      marketOptions: {
        immediate: true,
        deep: true,
        handler(val){
          let market = val.filter(r => r.id === this.data.marketId)[0]||{account:''};
          this.market = market
        }
      }
    },
    methods: {
      tabClick(){
        if(this.tabName==='log'){
          this.$refs.gjLog.$gjQuery()
        }
      },
      setTagColor(type) {
        let color = tagColors.blueDark
        switch(type) {
          case 'Message':
            color = tagColors.blueDark
            break;
          case '联系买家':
            color = tagColors.orangeDark
            break;
          case 'NR':
            color = tagColors.violetDark
            break;
          case 'NF':
            color = tagColors.yellowDark
            break;
          case '关怀邮件':
            color = tagColors.moreVioletDark
            break;
        }
        return color
      },
      //邮件设置匹配类型
      getDetailRelated(value){
        //获取邮件详情
        getBuyerEmailDetail(value.id).then((data) => {
          //若邮件状态为已关闭，则关闭当前邮件（场景：在review关闭邮件后，回到邮件页面）
          if(data.reviewRelateOrderStatus==='closed'){
            this.$emit('closeEmail')
          }
          //归档成功时无法弹出成功消息
          this.data = data;
          this.data.orderId = value.orderId
          let reviewFeedback = []
          if(this.data.isBeforeReview) {
            if(isMeaningful(this.data.reviewVO)) {
              reviewFeedback.push('reviewVO')
            }
            if(isMeaningful(this.data.feedbackVO)){
              reviewFeedback.push('feedbackVO')
            }
          } else {
            if(isMeaningful(this.data.feedbackVO)){
              reviewFeedback.push('feedbackVO')
            }
            if(isMeaningful(this.data.reviewVO)) {
              reviewFeedback.push('reviewVO')
            }
          }
          this.data.reviewFeedback = reviewFeedback
          this.$emit('load', this.data)
          this.market = this.marketOptions.filter(r => r.id === this.data.marketId)[0]||{account:''}
          if (isMeaningful(this.data) && isMeaningful(this.data.messages) && this.data.messages.length > 0) {
            this.data.messages.forEach(v => this.$set(v, 'more', false))
          }
          //获取回复模板
          let params = {
            countryCodeList: [],
            marketIdList: [this.data.marketId]
          }
          getMailTemplateList(params)
            .then((res) => {
              let data = res.data || []
              data.forEach((item) => {
                if (Array.isArray(item.marketMailTemplateVOList)) {
                  item.marketMailTemplateVOList.forEach((k) => {
                    this.emailTemplateMap[k.id] = k.content;
                  });
                }
                item.name = item.templateType;
              });
              this.emailTemplateOption = data;
            })

          if (isMeaningful(this.data.marketId) && isMeaningful(value.orderId)) {
            //获取邮件相关订单详情
            getRelatedOrder(this.data.marketId, value.orderId, this.mailType===mailTypeEnum.BUYER_MAIL?'Email':"EmailOrderListing",this.data.id).then((res) => {
              if(isMeaningful(res.listings) && res.listings.length > 0) {
                res.listings.forEach(item => {
                  item.tags = item.tags || []
                  item.tagIds = item.tags.map(items => items.id)
                })
              }
              this.relatedOrder = res;
            }).complete(() => this.relatedLoading = false)
          } else {
            this.relatedLoading = false;
          }

        }).complete(() => this.loading = false);
      },
      // feedback获取邮件详情
      getFeedbackDetail(value) {
        getResolveBadComment({id: value.feedbackId}).then((data) => {
          this.subject = data.subject;
          //若邮件状态为已关闭，则关闭当前邮件（场景：在review关闭邮件后，回到邮件页面）
          if(data.reviewRelateOrderStatus==='closed'){
            this.$emit('closeEmail')
          }
          //归档成功时无法弹出成功消息
          this.data = data;
          this.data.orderId = value.orderId
          let reviewFeedback = []
          if(this.data.isBeforeReview) {
            if(isMeaningful(this.data.reviewVO)) {
              reviewFeedback.push('reviewVO')
            }
            if(isMeaningful(this.data.feedbackVO)){
              reviewFeedback.push('feedbackVO')
            }
          } else {
            if(isMeaningful(this.data.feedbackVO)){
              reviewFeedback.push('feedbackVO')
            }
            if(isMeaningful(this.data.reviewVO)) {
              reviewFeedback.push('reviewVO')
            }
          }
          this.data.reviewFeedback = reviewFeedback
          this.market = this.marketOptions.filter(r => r.id === this.data.marketId)[0]||{account:''}
          this.$emit('load', this.data)
          if (isMeaningful(this.data) && isMeaningful(this.data.messages) && this.data.messages.length > 0) {
            this.data.messages.forEach(v => this.$set(v, 'more', false))
          }
          //获取回复模板
          let params = {
            countryCodeList: [],
            marketIdList: [this.data.marketId]
          }
          getMailTemplateList(params)
            .then((res) => {
              let data = res.data || []
              data.forEach((item) => {
                if (Array.isArray(item.marketMailTemplateVOList)) {
                  item.marketMailTemplateVOList.forEach((k) => {
                    this.emailTemplateMap[k.id] = k.content;
                  });
                }
                item.name = item.templateType;
              });
              this.emailTemplateOption = data;
            })

          if (isMeaningful(this.data.marketId) && isMeaningful(value.orderId)) {
            //获取邮件相关订单详情
            getRelatedOrder(this.data.marketId, value.orderId, this.mailType===mailTypeEnum.BUYER_MAIL?'Email':"EmailOrderListing",this.data.id).then((res) => {
              if(isMeaningful(res.listings) && res.listings.length > 0) {
                res.listings.forEach(item => {
                  item.tags = item.tags || []
                  item.tagIds = item.tags.map(items => items.id)
                })
              }
              this.relatedOrder = res;
            }).complete(() => this.relatedLoading = false)
          } else {
            this.relatedLoading = false;
          }

        }).complete(() => this.loading = false);
      },
      updateMatchResult(){
        updateMatchResult(this.data.matchResult,this.item.reviewRelateOrderId||this.data.feedbackId).then(res=>{
          this.$message.success('保存成功')
        })
      },
      // 设置为重要图标
      setStarMark() {
        let params = {
          ticketIds: [this.item.id],
          type: !this.data.isStar ? 1 : 0
        }
        setTicketCollection(params).then(res => {
          this.$gjMessage.success(res.data);
          this.getDetailRelated(this.item)
        })
      },
      //点击NR标签，弹窗review模块详情页
      openDetail() {
        this.$gjCreate(AppReviewDetail, {
          props: {
            id: this.data.reviewId,
            type:'email'
          },
          on: {
            close: () => {
              this.$emit('closeReview');
              this.getDetailRelated(this.item)
            }
          }
        });
      },

      //编辑邮箱
      editEmail() {
        const modal = this.$gjCreate(AppMailEditModal, {
          props: {
            item: {
              countryCode: this.market.countryCode,
              id: this.market.mailId,
              marketName: this.market.text,
              account: this.market.account,
              name: this.market.name
            }
          },
          on: {
            after: () => {
              modal.$gjDestroy();
              //编辑提交后刷新店铺相对应的邮箱状态
              this.$emit('getEmailAccount')
            }
          }
        })
      },

      // 前往店铺授权
      goMarketEmail() {
        this.$router.push({
          path: '/system/market',
          query: {
            marketId: this.data.marketId,
            timeStamp: new Date().getTime()
          }
        })
      },
      // 选择邮件模板
      emailgHandleChange(ev) {
        let  index = this.emailTemplateMap[ev].indexOf("<p>")
        if(index > -1) {
          this.sendMessage = this.emailTemplateMap[ev]
        } else {
          this.sendMessage = this.emailTemplateMap[ev].split(/\n/).map(line => `<p>${line}</p>`).join('\n')
        }
      },

      //归档
      placeOnFile(){
        let stateNRNF = isMeaningful(this.data.isBeforeReview)
        let params = {}
        if(stateNRNF) {
          params.id = this.data.isBeforeReview ? (this.data.feedbackId || this.item.reviewRelateOrderId) : this.item.reviewRelateOrderId
          params.mailType = this.data.isBeforeReview ? (this.data.feedbackId ? mailTypeEnum.NF : mailTypeEnum.NR): mailTypeEnum.NR
        } else {
          params.id = this.data.feedbackId || this.item.reviewRelateOrderId
          params.mailType = this.mailType
        }
        this.$gjCreate(PlaceOnFileModal,{
          props: {
            ...params,
            matchResult: this.data.matchResult
          },
          on: {
            placeAfter:()=>{
              this.$message.success('归档成功');
              this.tabClick();
              // // 邮件状态改为已处理,watch:item，重新查询邮件详情
              // this.data.ticketStatus = 'Done';
              //若是从review打开的弹框，则要手动调用刷新数据方法，watch item未知原因不生效
              if(this.type==='review'){
                this.getDetailRelated(this.item)
              }else if(this.type==='feedback'){
                this.getFeedbackDetail(this.feedbackItem)
              }
              // // 刷新未处理邮件数量接口
              this.$emit('closeReview','close');
            }
          }
        })
      },

      addMultiChannelOrder(id) {
        const vm = this;
        const modal = this.$gjCreate(AddMultiChannelOrder, {
          props: {
            id
          },
          on: {
            after() {
              vm.$gjResetPage();
              modal.$gjDestroy();
            }
          }
        });
      },

      refund(id) {
        const vm = this;
        const modal = this.$gjCreate(SaleOrderRefund, {
          props: {
            id: id,
          },
          on: {
            refund(data) {
              modal.loading = true;
              refund({
                id: id,
                marketId: vm.marketId,
                refundItemVos: data
              }).then(() => {
                vm.$gjMessage.success('操作成功');
                modal.$gjDestroy();
              }).complete(() => modal.loading = false)
            }
          }
        })
      },

      // 设置标签 保存备注
      tagIdsChange(item, ev) {
        const params = {
          fid: item.listtingId,
          marketId: this.data.marketId,
          module: "Email",
          orderId: this.data.orderId,
          tagAndAsinDTOList: [item],
          ticketId: this.data.id
        };
        saveTagToListing(params)
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success("设置成功");
              this.relatedLoading = true;
              if (isMeaningful(this.data.marketId) && isMeaningful(this.data.orderId)) {
                getRelatedOrder(this.data.marketId, this.data.orderId, this.mailType===mailTypeEnum.BUYER_MAIL?'Email':"EmailOrderListing", this.data.id).then((data) => {
                  if(isMeaningful(data.listings) && data.listings.length > 0) {
                    data.listings.forEach(item => {
                      item.tags = item.tags || []
                      item.tagIds = item.tags.map(items => items.id)
                    })
                  }
                  this.relatedOrder = data;
                }).complete(() => this.relatedLoading = false)
              } else {
                this.relatedLoading = false;
              }
            });
          })
      },

      //编辑标签窗口
      editTags(item){
        this.$gjCreate(MailTagsModal,{
          props:{
            item:item,
              marketId:this.relatedOrder.marketId,
              orderId:this.relatedOrder.orderId,
            mailType:this.mailType,
            ticketId:this.data.id
          },
          on:{
              created:()=>{
                  this.relatedLoading = true;
                  if (isMeaningful(this.data.marketId) && isMeaningful(this.data.orderId)) {
                    getRelatedOrder(this.data.marketId, this.data.orderId, this.mailType===mailTypeEnum.BUYER_MAIL?'Email':"EmailOrderListing",this.data.id).then((data) => {
                      if(isMeaningful(data.listings) && data.listings.length > 0) {
                        data.listings.forEach(item => {
                          item.tags = item.tags || []
                          item.tagIds = item.tags.map(items => items.id)
                        })
                      }
                      this.relatedOrder = data;
                    }).complete(() => this.relatedLoading = false)
                  } else {
                    this.relatedLoading = false;
                  }
              }
          }
        })
      },
      //修改邮件备注
      updateMemo() {
        updateCrmMemo({id: this.data.id, memo: this.data.memo})
          .then(() => {
            this.$gjMessage.success('保存成功');
          });
      },
      //标记跟踪、处理
      updateStatus(status) {
        this[status + 'Loading'] = true;
        updateStatus(this.data.id, status)
          .then(() => {
            this.$gjMessage.success('操作成功');
            // 刷新未处理邮件数量接口
            this.data.ticketStatus = status;
            this.$emit('closeReview','close');
            this.tabClick()
          }).complete(() => this[status + 'Loading'] = false)
      },
      resend(item) {
        let params = {id: item.id}
        this.resendLoading = true
        resendAgainEmail(params).then(res => {
          this.$gjMessage.success('操作成功');
          this.$emit('closeReview','close');
          if (this.type === 'feedback') {
            this.getFeedbackDetail(this.feedbackItem)
          } else {
            this.getDetailRelated(this.item)
          }
        }).catch(res => {
          this.$emit('closeReview','close');
          if (this.type === 'feedback') {
            this.getFeedbackDetail(this.feedbackItem)
          } else {
            this.getDetailRelated(this.item)
          }
        }).complete(() => this.resendLoading = false)
      },
      notPrompted(item) {
        let params = {id: item.id}
        remindIgnore(params).then(res => {
          if (this.type === 'feedback') {
            this.getFeedbackDetail(this.feedbackItem)
          } else {
            this.getDetailRelated(this.item)
          }
          this.$gjMessage.success('操作成功');
        })
      },
      send() {
        if (isMeaningless(this.market.account)) {
          this.$gjMessage.error('请先绑定售后邮箱');
          return
        }
        if(this.market.status!=='Normal'){
          this.$gjMessage.error(this.getMailAuthErrorMsg(this.market.status));
          return
        }
        if (isMeaningless(this.sendMessage) || isMeaningless(this.subject)) {
          this.$gjMessage.error('邮件内容和主题不能为空');
          return
        }
        this.sendLoading = true;
        sendMail({
          id: this.data.id,
          content: this.sendMessage,
          subject: this.subject,
          memo: this.remarks,
          attachments: isMeaningful(this.uploadAttFiles) ? this.uploadAttFiles.map(v => ({id: v.attId, name: v.name})) : [],
        }).then((res) => {
          this.$gjResponseHandle(res, () => {
            this.$gjMessage.success('发送成功');
            this.emailTemplate = null;
            this.sendMessage = '';
            this.remarks = '';
            // 邮件状态改回待处理
            // this.data.ticketStatus = 'Pending';
            this.noRemove = true;
            this.uploadAttFiles = [];
            if(this.data.ticketStatus === 'Done' || this.data.ticketStatus === 'Tracking' || this.data.ticketStatus === 'Finished'){
              //若邮件为已处理或待跟踪状态，关闭当前邮件，刷新邮件列表，新获取未处理邮件数
              this.$emit('closeReview','close');
            }else {
              //否则，重新获取未处理邮件数
              this.$emit('getPendingNum');
            }

            // this.loading = true;
            if (this.type === 'feedback') {
              this.getFeedbackDetail(this.feedbackItem)
            } else {
              this.getDetailRelated(this.item)
            }
          })
        }).catch(res=> {
          this.emailTemplate = null;
          this.sendMessage = '';
          this.remarks = '';
          // 邮件状态改回待处理
          // this.data.ticketStatus = 'Pending';
          this.noRemove = true;
          this.uploadAttFiles = [];
          if(this.data.ticketStatus === 'Done' || this.data.ticketStatus === 'Tracking' || this.data.ticketStatus === 'Finished'){
            //若邮件为已处理或待跟踪状态，关闭当前邮件，刷新邮件列表，新获取未处理邮件数
            this.$emit('closeReview','close');
          }else {
            //否则，重新获取未处理邮件数
            this.$emit('getPendingNum');
          }

          // this.loading = true;
          if (this.type === 'feedback') {
            this.getFeedbackDetail(this.feedbackItem)
          } else {
            this.getDetailRelated(this.item)
          }
        }).complete(() => {
          this.noRemove = false;
          this.sendLoading = false
        })
      },
      downloadAttFile(attId) {
        downloadAttFile(attId);
      },

      //点击关联订单打开订单详情
      opOrderDetail(marketId, orderId) {
        this.$gjCreate(SaleOrderDetail, {
          props: {
            marketId: marketId,
            orderId: orderId,
          }
        })
      },
      removeAttFile(attId) {
        this.uploadAttFiles = this.uploadAttFiles.filter(v => v.attId !== attId);
      },
      getMailAuthErrorMsg(status) {
        if (status === 'AuthCodeError') {
          return '密码/授权码错误';
        } else if (status === 'AuthFail') {
          return '授权失败';
        } else if (status === 'AuthCodeErrorAndAuthFail') {
          return '密码/授权码错误且授权失败';
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .reddot {
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #F53F3F;
    position: absolute;
    top: 12px;
    left: 8px;
  }
  .buyer-layout {
    width: 100%;
    height: 100%;
    //padding-bottom: 12px;
    box-sizing: border-box;
  }
  .buyer-layout a {
    cursor:pointer;
    color: #1F6EEF;
    text-decoration: unset;
  }
  .buyer-layout2 {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    //padding-bottom: 12px;
    box-sizing: border-box;
  }
  .buyer-content {
    flex: 1;
    max-height: calc(100vh - 170px);
    padding-left: 12px;
    box-sizing: border-box;
    margin-right: 3px;
    //border-right: 1px solid #ddd;
  }
  .buyer-email-detail {
    flex: none;
    font-size: 12px;
    height: 100%;
    overflow-y: auto;
    padding: 0px 17px 18px 12px;
    box-sizing: border-box;
    .buyer-email-detail-in{
      height: 100%;
      background: #FAFAFA;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
    }
  }
  @media screen and (max-width: 1440px) {
    .buyer-email-detail{
      .buyer-email-detail-in{
        padding: 10px;
        padding-right: 8px;
      }
    }

  }

    .color666 {
    color: #666;
  }
  .color444 {
    color: #333;
  }
  .editIcon{
    cursor: pointer;
    position: relative;
    //top:5px
  }
  .buyer-email {
    padding: 12px 0px 4px;
    border-bottom: 1px solid #EEEFF0;
    height: 66px;
    //margin-bottom: 10px;
    box-sizing: border-box;
  }
  .nrButton{
    height: 22px;
    width: 30px;
    border-radius:6px;
    padding: 0;
    margin-right: 12px;
  }
  .reply-detail {
    flex: 1;
    flex-direction:column;
    overflow: auto;
  }
  .reply-detail-title {
    margin-right: 9px;
    margin-left: 4px;
    padding: 8px 0 4px 0;
    position: relative;
    .el-alert--warning{
      background: #FFF5ED;
      border: 1px solid #F6BB90;
      border-radius: 2px;
      padding: 9px 16px;
    }

  }
  .reply-detail /deep/ .el-alert {
    padding: 4px 12px;
  }
  .message-mb15 {
    margin-bottom: 15px;
  }
  .reply-message {
    max-width: 65%;
    display: inline-block;
  }
  .reply-message-date {
    color: #666;
    margin-bottom: 6px;
  }
  .reply-message-content {
    flex: 1;
    padding: 10px 10px 10px 4px;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    min-height: 200px;
    &::-webkit-scrollbar-track{
      background: #f6f7f8;
    }
    .review-content {
      width: 75%;
    }
  }
  .reply-message-content:hover {
    overflow-y: overlay;
  }
  .reply-message-content-item {
    white-space: pre-wrap;
    word-break: break-all;
    padding: 8px 14px 10px 10px;
    background: #F6F8FB;
    border-radius: 4px;
    color: #333333;
    word-break: break-all;
    margin-top: 9px;
    position: relative;
    .reply-message-item-content {
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      margin: 6px 0;
      color: #666666;
    }
    .reply-message-send-succ {
      position: absolute;
      left: -18px;
      bottom: 0;
      font-size: 13px;
      color: #2DA641;
    }
  }
  .reply-message-remarks-item {
    white-space: pre-wrap;
    word-break: break-all;
    background: #EDF7FF;
    border-radius: 4px;
    padding: 4px 12px;
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    font-size: 12px;
    margin-top: 8px;
    .wid35 {
      width: 35px;
      flex: 0 0 auto;
    }
  }
  .reply-message-item--right {
    justify-content: flex-end;
    display: flex;
  }
  .reply-message-date--right {
    text-align: right;
  }
  .upload-att {
    padding-top: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }
  .upload-att > div {
    margin-right: 15px;
  }
  .att-close {
    cursor: pointer;
  }
  .reply-message-template {
    border-top: 1px solid #ddd;
    display: flex;
    padding: 12px 0 8px;
  }
  .order-detail-label {
    color: #666;
    text-align: right;
    min-width: 60px;
    width: auto;
  }
  .order-detail-textarea{
    width: 100%;
    height: 122px;
    /deep/ .el-textarea__inner{
      height: 100%;
    }

  }
  .order-detail-value {
    padding-left: 12px;
    padding-right: 10px;
    width:135px;
  }
  .line18 {
    line-height: 18px;
  }
  .column--color {
    background: #FAFBFC;
  }
  .column {
    flex: 1;
    justify-content: flex-end;
    align-items: center;
    font-size: 12px;
  }
  .column-label--color {
    color: #666;
  }
  .column-value--color {
    color: #333;
  }
  .tooLongTag{
        max-width: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .tagSpan{
        display: inline-block;
        margin: 0;
      height: 22px;
    }
    .contentLongTag{
    max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
}
.contenBox{
    max-width: 640px;
    max-height: 120px;
    overflow-y: auto;
}
.bgFFF1F0 {
  background: #FFF1F0;
}
.tagsBox{
  max-width: 260px;
  height: 22px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.paddBox{
    padding: 10px;
}
.bigBox{
  display: flex;
  max-width: 270px;
  margin-left: 12px;
}
/deep/ .el-alert{
    padding: 8px 12px;
}
/deep/  .el-alert__icon.is-big{
  font-size: 16px;
}
/deep/  .el-tabs__item{
  font-size: 12px;
  color: #666666;
  &.is-active{
    color: #333;
    font-weight: 600;
  }
}
/deep/ .el-tabs__header{
  margin: 0;
}
/deep/ .el-tabs__item{
  height: 30px;
  line-height: 30px;
  padding: 0 12.5px;
}
/deep/ .el-tabs__content{
  flex:1;
  .el-tab-pane{
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
.buyer-email-detail-top{
  overflow: auto;
  padding: 4px 0 8px 0;
  width: 248px;
  flex: 1;
  .top-item{
    margin-top: 8px;
    .top-item-label{
      color: #999999;
      margin-right: 12px;
      width: 60px;
      text-align: right;
    }
  }
  .gj-cell-display-switch{
    display: inline!important;
  }
  .buyer-email-detail-items{
    margin-top: 8px;
    padding-right: 10px;
    font-size: 12px;
    .list-item-title{
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .list-item-name{
      flex: none;
      width: 42px;
      margin-right: 6px;
      color: #666666;
    }
  }
}
.buyer-email-detail-bottom{
  padding: 12px 0;
  border-top: 1px solid #E4E5E6;
  .detail-bottom-icon{
    color: #999;
    font-size: 12px;
  }
}
  .detail-input{
    flex: 1;
    margin-left: 12px;
  }
/deep/ .el-popover__reference-wrapper{
  line-height: 0;
  display: block;
}
/deep/ .el-popover__reference{
  height: 40px;
}
/deep/ .gj-help--icon{
  color: #999;
}
.tagLabel {
  height: 32px;
  line-height: 32px;
  color: #666;
}
.wid240 {
  max-width: 240px;
}
</style>
